import { render, staticRenderFns } from "./vLink.vue?vue&type=template&id=2c466275&scoped=true"
import script from "./vLink.vue?vue&type=script&lang=js"
export * from "./vLink.vue?vue&type=script&lang=js"
import style0 from "./vLink.vue?vue&type=style&index=0&id=2c466275&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c466275",
  null
  
)

export default component.exports